<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_status=== true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete=== true">ลบบทความเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="text-right mb-2">
            <v-btn color="#28ab28" class="white--text" @click="$router.push('/contentaddblog')" width="20%" height="65">
                บทความใหม่
            </v-btn>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.date}}</td>
                        <td>
                            <div class="image_content_blog_list">
                                <img :src="dataDetail.item.cover_image">
                            </div>
                        </td>
                        <td>{{dataDetail.item.title}}</td>
                        <td>{{dataDetail.item.user_name}}</td>
                        <td>
                            <span>
                                <v-switch color="success" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                            </span>
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" width="50">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_content_blog_list" @click="blogDetail(dataDetail.item.id)">
                                        <v-list-item-title>แก้ไขบทความ</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_content_blog_list" @click="openDeleteBlog(dataDetail.item.id)">
                                        <v-list-item-title>ลบบทความ</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="open_confirm_delete" persistent max-width="600">
            <v-card>
                <v-card-title>
                    ลบบทความ
                </v-card-title>

                <v-card-text>
                    ท่านต้องการลบบทความ ใช่ หรือ ไม่ ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" height="50" @click="deleteBlog()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" height="50" @click="open_confirm_delete = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import contentblog from '@/api/content/contentblog/contentblog.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            open_confirm_delete: false,
            alert_show_status:false,
            alert_show_delete: false,
            edit_id: null,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'date',
                    value: 'date'
                },
                {
                    text: 'รูปภาพ',
                    value: 'cover_image'
                },
                {
                    text: 'หัวเรื่อง',
                    value: 'title'
                },
                {
                    text: 'ผู้สร้าง',
                    value: 'user_name'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async blogList() {
            this.loading_page = true
            contentblog.blogList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.posts
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async changeStatus(id) {
            contentblog.changeStatusBlog(id).then((response) => {
                if (response.data.successful === true) {
                    this.alert_show_status = true
                    setTimeout(() => this.alert_show_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async blogDetail(id) {
            const idPage = {
                id: id,
            }
            this.$store.commit('detailBlogPage', idPage)
            this.$router.push('/contenteditblog')
        },
        async openDeleteBlog(id) {
            this.edit_id = id
            this.open_confirm_delete = true
        },
        async deleteBlog() {
            this.open_confirm_delete = false
            this.loading_page = true
            contentblog.deleteBlog(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = null
                    this.blogList()
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.blogList()
    }
}
</script>

<style scoped>
.image_content_blog_list {
    width: 100px;
}

.image_content_blog_list>img {
    max-width: 100%;
}

.cursor_content_blog_list {
    cursor: pointer;
}
</style>
